import React from "react";
import { Container, Row, Col, Card, Button, ListGroup } from "react-bootstrap";
import {
  FaPaintBrush,
  FaPlane,
  FaDownload,
  FaFileAlt,
  FaRocket,
  FaCut,
} from "react-icons/fa";
import "./ColoringPages.css";

function ColoringPages() {
  // Available coloring documents - can be expanded as more are added
  const coloringDocuments = [
    {
      id: "airline",
      title: "Airline Adventure",
      description:
        "Color exciting scenes from the airline industry including planes, airports, and flight crew!",
      icon: <FaPlane />,
      filename: "airline.pdf",
      available: true,
      fileSize: "83 KB",
      pages: "Multiple coloring pages",
    },
    {
      id: "astronaut",
      title: "Space Mission",
      description:
        "Color amazing space adventures with astronauts, rockets, planets, and stars!",
      icon: <FaRocket />,
      filename: "astronaut.pdf",
      available: true,
      fileSize: "176 KB",
      pages: "Multiple coloring pages",
    },
    {
      id: "beauty_shop",
      title: "Beauty Shop",
      description:
        "Color stylish salon scenes with haircuts, styling tools, and glamorous makeovers!",
      icon: <FaCut />,
      filename: "beauty_shop.pdf",
      available: true,
      fileSize: "167 KB",
      pages: "Multiple coloring pages",
    },
    // Template for future additions:
    // {
    //   id: "hotel",
    //   title: "Hotel Management",
    //   description: "Coming soon! Color scenes from hotel operations and hospitality.",
    //   icon: <FaHotel />,
    //   filename: "hotel.pdf",
    //   available: false,
    //   fileSize: "TBD",
    //   pages: "Coming soon"
    // }
  ];

  const handleDownload = (filename) => {
    const link = document.createElement("a");
    link.href = `/coloring-pages/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container fluid className="coloring-pages">
      <div className="text-center mb-5">
        <h1>
          <FaPaintBrush className="me-3" />
          Coloring Pages
        </h1>
        <p className="lead">
          Download and print fun coloring pages based on our educational games!
        </p>
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={8} xl={6}>
            <Card className="coloring-list-card">
              <Card.Header className="d-flex align-items-center">
                <FaFileAlt className="me-2" />
                <h4 className="mb-0">Available Coloring Documents</h4>
              </Card.Header>
              <ListGroup variant="flush">
                {coloringDocuments.map((doc, index) => (
                  <ListGroup.Item
                    key={doc.id}
                    className="coloring-list-item"
                    style={{ "--index": index }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center flex-grow-1">
                        <div className="coloring-icon me-3">{doc.icon}</div>
                        <div className="coloring-info flex-grow-1">
                          <h5 className="coloring-title mb-1">{doc.title}</h5>
                          <p className="coloring-description mb-1">
                            {doc.description}
                          </p>
                          <div className="coloring-meta">
                            <small className="text-muted">
                              {doc.pages} • {doc.fileSize}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="coloring-action ms-3">
                        {doc.available ? (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleDownload(doc.filename)}
                            className="coloring-download-btn"
                          >
                            <FaDownload className="me-2" />
                            Download
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            disabled
                          >
                            Coming Soon
                          </Button>
                        )}
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card>
          </Col>
        </Row>

        {/* Add info section */}
        <Row className="mt-5">
          <Col lg={8} className="mx-auto">
            <div className="alert alert-info">
              <h5 className="alert-heading">
                <FaPaintBrush className="me-2" />
                How to Use Coloring Pages
              </h5>
              <ul className="mb-0">
                <li>Click "Download" to get the coloring page PDF</li>
                <li>Print the PDF on regular paper (8.5" x 11")</li>
                <li>Use crayons, colored pencils, or markers to color</li>
                <li>Have fun and be creative with colors!</li>
                <li>Share your finished artwork with family and friends</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ColoringPages;
